import { render } from "./SideBarMenu.vue?vue&type=template&id=3cf18f93&scoped=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=3cf18f93&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf18f93"]])

export default __exports__